import { Utils } from '../../Core';
import { uploadFileS3Api as API } from '../../Apis';
import { UploadFileS3Types } from '../../Types';
import { mocksService } from './UploadFileS3.mocks';
import dataFields from '../../Types/UploadFileS3.json';

const invokeApiFunction = (stateRequestParameters: {
  category: keyof typeof UploadFileS3Types.CategoryUploadType;
  extension: string;
  file: string;
}) =>
  API.call.post({
    category:
      UploadFileS3Types.CategoryUploadType[stateRequestParameters.category],
    extension: stateRequestParameters.extension,
    file: stateRequestParameters.file,
  });

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction,
  definitionsAPI: API.definitions,
  mocksService,
  dataFields,
});
